import { Menu, MenuItem } from "@mui/material";
import { ImportContactsRounded, EditRounded } from "@mui/icons-material";
import useAuth from "../../hoc/AuthProvider/useAuth";
import { Permissions } from "../../config/permissions";

type ParserConfigMenuProps = {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  onView: () => void;
  onEdit: () => void;
};

const ParserConfigMenu: React.FC<ParserConfigMenuProps> = ({
  anchorEl,
  onClose,
  onView,
  onEdit,
}) => {
  const { havePermission } = useAuth();
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      sx={{ borderRadius: "35px" }}
    >
      {havePermission(Permissions.ParserConfig_Update) && (
        <MenuItem onClick={onEdit} sx={{ gap: "5px" }}>
          <EditRounded />
          {"Parser Düzenle"}
        </MenuItem>
      )}
      <MenuItem onClick={onView} sx={{ gap: "5px" }}>
        <ImportContactsRounded />
        {"Parser Veri Ayarları"}
      </MenuItem>
    </Menu>
  );
};

export default ParserConfigMenu;
